module.exports = "/fonts/Ki.woff?f2362a7b881b57280ab585a85ec61a8f";